import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { DanoneMslProduct } from 'src/app/assabil-sales/models/entities/danone-msl_product';
import { DanoneDnProductFamily } from 'src/app/assabil-sales/models/entities/danone-dn-product-family';
import { SalesAdminDanoneService } from 'src/app/assabil-sales/services/sales-admin-danone-service';


@Component({
  selector: 'danone-dn-product-family-list',
  templateUrl: './danone-dn-product-family-list.component.html',
  styleUrls: ['./danone-dn-product-family-list.component.scss']
})


export class DanoneDnProductFamilyListComponent extends BasePage2<DanoneDnProductFamily> {

  danoneDnProductFamilies : DanoneDnProductFamily[] = [];

  formFields = [];

  c1   = {prop : "danoneDnProductFamilyCode",  name:"Code",              readOnly : false, insertOnly : true};
  c2   = {prop : "name",                       name:"Nom",               readOnly : false};
  c3   = {prop : "dayNumber",                  name:"Nbre de jours",     readOnly : false, type :'number'};
  c4   = {prop : "trendDaysNumber",            name:"Tendance / jours",  readOnly : false, type :'number'};

  visible1  : boolean = true;
  visible2  : boolean = true;
  visible3  : boolean = true;
  editable1 : boolean = false;
  editable2 : boolean = false;
  editable3 : boolean = false;

  constructor(
    protected danoneService     : SalesAdminDanoneService,
    protected toastr            : ToastrService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected location          : Location) {
   
       super(toastr, router, baseService, leanUtilsService, location);

       this.entityName = 'danoneMslProduct';

       this.listFields = [
        this.c1,     
        this.c2,  
        this.c3,  
        this.c4,
      ];

      this.formFields = this.listFields;
    }



  initEntityContainer() {
    this.entityContainer = new EntityContainer(DanoneDnProductFamily);
  }

  getRows(): DanoneDnProductFamily[] {
    return this.danoneDnProductFamilies;
  }

  saveRow(row: DanoneMslProduct): Promise<DanoneDnProductFamily> {
    return null; 
  }

  loadData() {
    this.danoneService.danoneDnProductFamiliesGet().then(result => {
       this.danoneDnProductFamilies = result;
    })
  }

      
  selectRow(row : any){
    this.danoneService.danoneDnProductFamilyGet(row.danoneDnProductFamilyCode).then(result => {
        this.selectedRow = result;
    })
  }

  new(){
    
    //-----------------------------------------------------------------------------
    let newRow : DanoneDnProductFamily = new DanoneDnProductFamily();
    newRow.inserted = true;
    newRow.edit = true;
    //-----------------------------------------------------------------------------

    this.selectedRow = newRow;
  }

}
    
  